export default [
    { "id": 2, "name": "Telegram", "slug": "telegram" },
    { "id": 1, "name": "Facebook", "slug": "facebook" }
];
